import React from "react";
import {useSelector} from "react-redux";

import AppreciationTabInputText from "../../component/appreciation/AppreciationTabInputText";
import LoadingIndicator from "../../component/LoadingIndicator";
import ValueLendingValueInfo from "../../component/ValueLendingValueInfo";
import {useRevaTranslation} from "../../hooks/languageHooks";
import {selectAllFirstFinalizeParams} from "../../redux/objectParametersSlice";
import {selectFirstFinalizeDate, selectPersistenceLoading} from "../../redux/persistenceSlice";
import {selectLoading as selectSpecLoading} from "../../redux/specSlice";
import {formatDateAndTime} from "../../util/dateUtil";
import ErrorMessageContainer from "./ErrorMessageContainer";
import {ObjectOutputGrid} from "./ObjectOutputGrid";

/**
 * @returns {React.JSX.Element}
 */
function TabObjectFinalize() {
    const {t, language} = useRevaTranslation();
    const firstFinalizeValues = useSelector(selectAllFirstFinalizeParams);
    const firstFinalizeDate = useSelector(selectFirstFinalizeDate);
    const specLoading = useSelector(selectSpecLoading);
    const persistenceLoading = useSelector(selectPersistenceLoading);
    const loading = specLoading || persistenceLoading;

    return (
        <div className="flex-1">
            <AppreciationTabInputText page="object" tab="finalize" />
            <ValueLendingValueInfo />
            <ErrorMessageContainer />
            <LoadingIndicator loading={loading} className="h-full" />
            {!loading && (
                <>
                    <div className="text-lg mb-6 py-2 text-color text-center">
                        {firstFinalizeDate &&
                            t("object.finalizationExecuted", {
                                date: formatDateAndTime(firstFinalizeDate, language),
                            })}
                    </div>
                    <ObjectOutputGrid outputData={firstFinalizeValues} fullsize={true} />
                </>
            )}
        </div>
    );
}

export default TabObjectFinalize;
